const editable = (el) => el?.closest?.("input, textarea, [contenteditable='true']");

export const enableCopyProtection = () => {
  const onContext = (e) => {
    if (!editable(e.target)) e.preventDefault();
  };
  const onDrag = (e) => {
    if (e.target?.tagName === "IMG" || e.target?.tagName === "svg") e.preventDefault();
  };
  const onCopy = (e) => {
    if (!editable(e.target)) e.preventDefault();
  };
  const onKey = (e) => {
    const k = e.key?.toLowerCase();
    const mod = e.ctrlKey || e.metaKey;
    if (e.key === "F12") return e.preventDefault();
    if (mod && e.shiftKey && ["i", "j", "c"].includes(k)) return e.preventDefault();
    if (mod && ["u", "s", "p"].includes(k)) return e.preventDefault();
    if (mod && ["c", "x", "a"].includes(k) && !editable(e.target)) e.preventDefault();
  };
  document.addEventListener("contextmenu", onContext);
  document.addEventListener("dragstart", onDrag);
  document.addEventListener("copy", onCopy);
  document.addEventListener("cut", onCopy);
  document.addEventListener("keydown", onKey);
  return () => {
    document.removeEventListener("contextmenu", onContext);
    document.removeEventListener("dragstart", onDrag);
    document.removeEventListener("copy", onCopy);
    document.removeEventListener("cut", onCopy);
    document.removeEventListener("keydown", onKey);
  };
};
